module.exports = __webpack_public_path__ + "media/images/ai_brain_topics/address_change-61164221e8a6599f96df7be50cbfab86.png";